import { render, staticRenderFns } from "./savedAnimation.vue?vue&type=template&id=1a5a5139&scoped=true&"
import script from "./savedAnimation.vue?vue&type=script&lang=js&"
export * from "./savedAnimation.vue?vue&type=script&lang=js&"
import style0 from "./savedAnimation.vue?vue&type=style&index=0&id=1a5a5139&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a5139",
  null
  
)

export default component.exports